// extracted by mini-css-extract-plugin
module.exports = {"header":"index-module__header___BNKRT","card":"index-module__card___hmdUr","section_header":"index-module__section_header___vraMw"};